import { BooleanInput, NumberInput, SimpleForm, TextInput, required } from "react-admin";
import { CardImageInput } from "./ImageInput";

export function CardDesignForm() {
  return (
    <SimpleForm>
      <TextInput source="name" label="Название" validate={required()} fullWidth helperText="Напр. «Премиальная»" />
      <TextInput
        source="description"
        label="Описание"
        fullWidth
        multiline
        helperText="Подзаголовок, напр. «Для тех, кто совершает много покупок за границей»"
      />
      <CardImageInput />
      <NumberInput source="cost_rub" label="Стоимость открытия, ₽" min={0} step="any" />
      <NumberInput source="exchange_rate" label="Курс обмена, ₽ за $1" min={0} step="any" helperText="Напр. 85.04" />
      <TextInput source="currency" label="Валюта (чип)" defaultValue="USD" helperText="Напр. USD" />
      <BooleanInput
        source="coming_soon"
        label="Скоро (недоступна к выпуску)"
        defaultValue={true}
        helperText="Картинка приглушается + надпись «Скоро»"
      />
      <BooleanInput source="best_rate" label="Значок «Лучший курс»" defaultValue={false} />
      <NumberInput source="sort_order" label="Порядок в списке" min={0} defaultValue={0} />
      <BooleanInput source="enabled" label="Показывать в каталоге" defaultValue={true} />
    </SimpleForm>
  );
}
